import {
  onSelectScriptTypeOptions,
  onSelectManagementZones,
  onEnterPlantingPlan,
  onFinishFlow
} from './stepActions';

const stepActions = [
  onSelectScriptTypeOptions,
  onSelectManagementZones,
  onEnterPlantingPlan,
  onFinishFlow
];

export default {
  stepActions
};
